import { IPlatform } from "./../../interfaces/i-platform";
import { environment } from "environments/environment";
import { ApiPlatformService } from "./../../services/api/api-platform-service.service";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationsService } from "angular2-notifications";
import { TicketStatuses } from "app/enums/TicketStatuses.enum";
import { ITicket } from "app/interfaces/i-ticket";
import { ApiQueueService } from "app/services/api/api-queue.service";
import { ApiTicketService } from "app/services/api/api-ticket.service";
import { LocalStorageService } from "app/services/local-storage/local-storage.service";
import { SocketService } from "app/services/socket/socket.service";
import { assign, find, isEmpty } from "lodash";
import { merge, of, Subscription } from "rxjs";
import { filter, mergeMap, switchMap } from "rxjs/operators";
import { DialogConfirm } from "../dialog-confirm/dialog-confirm.component";
import { GoogleAnalyticsService } from "./../../services/analytics/google-analitics-service";
import { TicketTransport } from "app/enums/TicketTransport.enum";
import { ApiArticleService } from "app/services/api/api-article-service";
import { INewsDetail } from "app/interfaces/i-news";
import { ArticleCategary } from "app/enums/article-categary.enum";

@Component({
    standalone: false,
    selector: "app-waiting",
    templateUrl: "./waiting.component.html",
    styleUrls: ["./waiting.component.scss"],
})
export class WaitingComponent implements OnInit, OnDestroy {
    public ticketInWaiting: number;
    public operatorOnline: number;
    public operatorBusy: number;
    public operatorFree: number;
    public service: string;
    public ticketServiceRef: any;
    public slides: INewsDetail[];
    private platform: IPlatform;
    private newTicket: ITicket;
    private updateQueueSubscription: Subscription;
    private updateTicketSubscription: Subscription;
    private ticketID: number;

    constructor(
        private router: Router,
        private activeRoute: ActivatedRoute,
        private queueService: ApiQueueService,
        private socket: SocketService,
        private ticketService: ApiTicketService,
        public dialog: MatDialog,
        private storage: LocalStorageService,
        public toast: NotificationsService,
        private articleService: ApiArticleService,
        private googleAnalyticsService: GoogleAnalyticsService,
        private platformService: ApiPlatformService,
    ) {
        this.ticketID = +this.activeRoute.snapshot.paramMap.get("id");
        this.updateTicketSubscription = merge(
            this.ticketService.getFromId(this.ticketID),
            this.socket.getMessage("onTicketUpdated"),
        )
            .pipe(filter((ticket) => ticket.id === this.ticketID))
            .subscribe((ticket) => {
                this.newTicket = ticket;
                this.ticketServiceRef = find(
                    this.storage.getItem("ticket_service"),
                    ["id", this.newTicket.id_service],
                );
                if (
                    ticket.id_status !== TicketStatuses.ONLINE &&
                    ticket.id_status !== TicketStatuses.NEW
                ) {
                    this.toast.error(
                        "Nuovo Ticket",
                        "Richiesta non accettata!",
                    );
                    this.router.navigate(["home"]);
                } else if (ticket.id_status === TicketStatuses.ONLINE) {
                    if (
                        this.ticketServiceRef.transport === TicketTransport.CHAT
                    ) {
                        this.router.navigate(["chat", this.ticketID]);
                    } else {
                        this.router.navigate(["videochat", this.ticketID]);
                    }
                }
            });

        this.updateQueueSubscription = merge(
            this.socket.getMessage("onOperatorSessions"),
            this.socket.getMessage("onTicketInWaiting"),
            of(null),
        )
            .pipe(
                mergeMap(() => {
                    return this.queueService.apiGetQueueData(this.ticketID);
                }),
            )
            .subscribe((fromApiQueue) => {
                this.ticketInWaiting = fromApiQueue.ticketInWaiting;
                this.operatorBusy = fromApiQueue.operatorBusy;
                this.operatorOnline = fromApiQueue.operatorActive;
                const operatorFree = this.operatorOnline - this.operatorBusy;
                this.operatorFree = operatorFree < 0 ? 0 : operatorFree;
            });

        this.platformService
            .getOneById(environment.platform_id)
            .pipe(
                switchMap((platform: IPlatform) => {
                    this.platform = platform;
                    return this.articleService.getRandomUsingPost({
                        id_tenant: this.platform.id_tenant,
                    });
                }),
            )
            .subscribe((response) => {
                let contents: INewsDetail[] = [];
                if (!isEmpty(response.details)) {
                    contents = response.details;
                    delete response.details;
                }

                if (!isEmpty(response)) {
                    this.slides = [response as INewsDetail].concat(contents);
                }
            });
    }

    ngOnInit(): void {
        this.googleAnalyticsService.pageEmitter("/WaitingPage");
    }

    ngOnDestroy(): void {
        this.updateQueueSubscription.unsubscribe();
        this.updateTicketSubscription.unsubscribe();
    }

    setMyStyles(): any {
        const style = {
            color: this.ticketServiceRef
                ? this.ticketServiceRef.color
                : "white",
        };
        return style;
    }

    exit(): void {
        this.dialog
            .open(DialogConfirm, {
                data: {
                    msg: "Sei sicuro di voler abbandonare la tua richiesta?",
                },
            })
            .afterClosed()
            .pipe(
                filter((data) => !!data),
                mergeMap(() => {
                    const ticket: ITicket = assign({}, this.newTicket, {
                        id_status: TicketStatuses.ARCHIVED,
                    });
                    return this.ticketService.update(ticket);
                }),
            )
            .subscribe({
                next: (data) => {
                    this.googleAnalyticsService.eventEmitter(
                        "WaitingPage",
                        "Cancel Request",
                    );
                    this.toast.success("Nuovo Ticket", "Richiesta Annullata!");
                    this.router.navigate(["home"]);
                },
                error: (err) => {
                    console.error(err);
                    this.toast.error(
                        "Nuovo Ticket",
                        "Richiesta di annullamento non è andata a buon fine!",
                    );
                },
            });
    }
}
